import React from 'react'
import { feedbotToast } from '../../lib/feedbotToast'

export const toastNotifyNlpTrainingError = (utterance: string) => {
  const id = 'nlpTrainingError'

  const title = 'NLP training failed'

  const content = (
    <>
      We were unable to assign the following unmatched utterance to intent: <b>{utterance}</b>.
      Please, try it again or contact{' '}
      <a
        target="_blank"
        rel="noopener noreferrer"
        href="https://feedyou.atlassian.net/servicedesk/customer/portals"
      >
        our support
      </a>
      .
    </>
  )

  feedbotToast.error({ title, content, id })
}

export const toastNotifyNlpTrainingSuccess = (utterance: string, intentId: string) => {
  const id = 'nlpTrainingSucces'

  const title = 'Training successful'

  const content = (
    <>
      The following example has been assigned to intent <b>{intentId}</b>:<br />
      <br /> {utterance}
    </>
  )

  feedbotToast.success({ title, content, id })
}

export const toastNotifyNlpIgnoreError = (utterance: string) => {
  const id = 'nlpTrainingIgnoreError'

  const title = 'Adding to ignored failed'

  const content = (
    <>
      We were unable to add the following unmatched utterance to ignored list: <b>{utterance}</b>.
      Please, try it again or contact{' '}
      <a
        target="_blank"
        rel="noopener noreferrer"
        href="https://feedyou.atlassian.net/servicedesk/customer/portals"
      >
        our support
      </a>
      .
    </>
  )

  feedbotToast.error({ title, content, id })
}

export const toastNotifyNlpIgnoreSuccess = (utterance: string) => {
  const id = 'nlpTrainingSucces'

  const title = 'Ignoring successful'

  const content = <>The example has been added to ignored ({utterance})</>

  feedbotToast.success({ title, content, id })
}
